module.exports = __webpack_public_path__ + "img/生成发票.3c75a94d.svg";